import {
  Box, Container, Typography, useMediaQuery, useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageTransition } from '../Onboarding/Home/common/PageTransition';
import { useSolutionOrg } from '../../config/useSolutionOrg';
import { useLogo } from '../../config/useLogo';

interface SplashScreenSecondVariantProps {
  CallToActionBtn: ({ btnText }: {btnText:string})=>JSX.Element;
  Footer: ({ setupBtnText }: { setupBtnText: string; })=>JSX.Element;
  heading?: string;
  subHeading?: string;
  imageUrl?: string;
  ctaText?: string;
}

export function SplashScreenSecondVariant({
  CallToActionBtn,
  Footer,
  heading,
  subHeading,
  imageUrl,
  ctaText,
}:SplashScreenSecondVariantProps) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const { t } = useTranslation();
  const { solutionOrgSpecificAppName } = useSolutionOrg();
  const { secondaryOne: Logo } = useLogo();
  const setupBtnText = ctaText ? `${ctaText}` : `${t('button.access')}`;

  const BannerImg = () => (
    <img src={imageUrl || 'https://d2o7bp9oz3gksv.cloudfront.net/splash_screen_banner_a_5d8a5e3b32.png'}
      width={'100%'}
      height={'auto'}
      alt='splash screen banner' />
  );

  const Headings = () => (
    <Box display='flex' alignItems={'center'} flexDirection={'column'}
      sx={{ width: '100%' }}>
      <Typography textAlign={'center'} variant='h8'
        sx={{
          fontSize: '28px',
          marginBottom: theme.spacing(2.5),
          [theme.breakpoints.down('md')]: {
            marginBottom: theme.spacing(1.5),
            fontSize: theme.spacing(3),
            fontWeight: 600,
          },
        }}
      >
        {heading || t('onboarding.splashScreen.heading1')}
      </Typography>
      <Typography textAlign={'center'} variant='body1'
        sx={{
          marginBottom: theme.spacing(1.5),
          [theme.breakpoints.up('md')]: {
            marginBottom: theme.spacing(4),
            fontsize: theme.spacing(2.25),
            fontWeight: 600,
          },
        }}
      >
        {subHeading || t('onboarding.splashScreen.heading2', { solutionOrgSpecificAppName })}
      </Typography>
    </Box>
  );

  return (
    <>
      {Logo &&
      <Box display={'flex'} justifyContent={'center'}
        sx={{
          marginTop: theme.spacing(4),
          [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(3),
          },
          [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(1),
          },
        }}
      >
        <img
          src={Logo as string}
          alt="Logo"
          height={43}
          width={204}
        />
      </Box>
      }
      {isDesktop ?
        <PageTransition>
          <Box
            sx={{
              marginTop: theme.spacing(4),
              maxWidth: theme.spacing(54.125),
              marginLeft: 'auto',
              marginRight: 'auto',
            }}>
            <Box display={'flex'} alignItems={'center'} flexDirection={'column'}
              sx={{
                marginBottom: theme.spacing(1.5),
              }}
            >
              <Headings/>
              <Box display={'flex'} justifyContent={'center'}>
                <BannerImg />
              </Box>
            </Box >
            {CallToActionBtn && <CallToActionBtn
              btnText={setupBtnText}
            />}
            {Footer && <Footer setupBtnText={setupBtnText} />}
          </Box>
        </PageTransition > :
        <Box >
          <Container
            sx={{
              textAlign: 'center',
              maxWidth: theme.spacing(54.125),
              marginTop: theme.spacing(3),
              paddingTop: theme.spacing(0),
              paddingBottom: theme.spacing(4),
            }}
          >
            <Headings/>
            <BannerImg />
            <Box
              sx={{
                position: 'sticky',
                bottom: 0,
                paddingTop: theme.spacing(2.5),
                paddingBottom: theme.spacing(2),
                backgroundColor: theme.palette.grey[100],
                [theme.breakpoints.down('sm')]: {
                  paddingTop: theme.spacing(2.5),
                },
              }}
            >
              {CallToActionBtn && <CallToActionBtn
                btnText={setupBtnText}
              />}
            </Box>
            {Footer && <Footer setupBtnText={setupBtnText} />}
          </Container>
        </Box>}
    </>
  );
}
